import React, {useReducer} from "react";
import {makeStyles} from "@material-ui/styles";
import BoldTypography from "components/BoldTypography";
import useEzamowieniaOauth from "hooks/useEzamowieniaOauth";
import Tr from "translations/Translations";
import Typography from "components/Typography";
import Button from "components/Button";
import EZamowieniaIcon from "components/icon/EZamowieniaIcon";
import previewFile from "libs/previewFile";
import EzamowieniaService from "services/EzamowieniaService";
import iconWorksReducer from "libs/iconWorksReducer";
import Endpoints from "constants/Endpoints";
import PapersGeneratorService from "services/PapersGeneratorService";
import WorkableButton from "components/button/WorkableButton";
import GetAppIcon from '@material-ui/icons/GetApp';

const useStyle = makeStyles(theme => ({
    marginBottom: {
        marginBottom: theme.spacing(2)
    },
    marginLeft: {
        marginLeft: theme.spacing()
    },
}))
const PapersGeneratorXmpUzpPresidentPaperContent = (
    {
        demandId
    }) => {

    const classes = useStyle();
    const {authorizeEzamowienia} = useEzamowieniaOauth();
    const [iconWorks, dispatchIconWorks] = useReducer(iconWorksReducer, {
        anyWorks: false,
        download: false,
        goto: false
    });

    const goTo = () => {
        authorizeEzamowienia(() => {
            dispatchIconWorks({type: 'download', works: true});
            EzamowieniaService.getAuthorizationStatus().then((resp) => {
                let ezamowieniaOrigin = "https://ezamowienia.gov.pl";
                if (resp) {
                    ezamowieniaOrigin = resp.ezamowieniaOrigin;
                }
                previewFile({url: ezamowieniaOrigin + "/pl/formularz/"})
            }).finally(() => dispatchIconWorks({type: 'download', works: false}))
        })
    }

    const download = () => {
        dispatchIconWorks({type: 'download', works: true});
        PapersGeneratorService.downloadPaper(Endpoints.XMM_UZP_PRESIDENT_PAPER(demandId), () =>
            dispatchIconWorks({type: 'download', works: false}), () => dispatchIconWorks({type: 'download', works: false}))
    }


    return (<>
        <BoldTypography className={classes.marginBottom}>{Tr("xmp_uzp_paper_title")}</BoldTypography>

        <Typography>{Tr("xmp_uzp_paper_steps")}</Typography>

        <ol>
            <li className={classes.marginBottom}>
                <Typography>
                    {Tr("xmp_uzp_paper_step1")}
                    <WorkableButton Icon={GetAppIcon} onClick={download} disabled={iconWorks.anyWorks} working={iconWorks.download} className={classes.marginLeft}>{Tr("download") + " XML"}</WorkableButton>
                </Typography>
            </li>
            <li>
                <Typography>
                    {Tr("xmp_uzp_paper_step2")}
                    <Button onClick={goTo} className={classes.marginLeft} Icon={EZamowieniaIcon} disabled={iconWorks.anyWorks}>
                        {Tr("ezamowienia_go_to")}
                    </Button>
                </Typography>
            </li>
        </ol>


    </>)
}

export default PapersGeneratorXmpUzpPresidentPaperContent;